import { useSyncExternalStore } from 'react';
import {
  addSongListSyncListener,
  getSongListSaveRefusal,
  removeSongListSyncListener,
  SongListSaveRefusal,
} from './use_current_org.tsx';

/**
 * The current song list save refusal (issue #3609), kept up to date as sync passes finish. It reflects
 * state, not events: a pass refused again for the same reason keeps the previous value, so nothing
 * re-renders.
 */
export function useSongListSaveRefusal(): SongListSaveRefusal | undefined {
  return useSyncExternalStore(subscribe, getSnapshot);
}

function subscribe(onChange: () => void) {
  addSongListSyncListener(onChange);
  return () => removeSongListSyncListener(onChange);
}

// every refused pass makes a new refusal object, so compare by value and keep the one already shown
let snapshot: SongListSaveRefusal | undefined;

function getSnapshot(): SongListSaveRefusal | undefined {
  const next = getSongListSaveRefusal();
  if (!(snapshot && next && snapshot.status === next.status && snapshot.message === next.message)) {
    snapshot = next;
  }
  return snapshot;
}
